import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
// import {Projects} from "../../../../../shared/Models/Projects";
import { environment } from 'src/environments/environment.prod';
import {DonationWayService} from '../../../../shared/API-Service/services/donation-way.service'
import {DonationWay} from '../../../../shared/Models/DonationWay'
@Component({
  selector: 'app-insert-donation-way',
  templateUrl: './insert-donation-way.component.html',
  styleUrls: ['./insert-donation-way.component.css']
})
export class InsertDonationWayComponent implements OnInit {
  id: string;
  update: boolean;
  insertForm: FormGroup;
  DonationWays = new DonationWay();
  imageLogo:any
  Image: any;
  CreatDonationWayorm: any = new FormData();
  DonationWay: any;
  BtnDisaple: boolean;
  constructor(private DonationWayService :DonationWayService,private _formBuilder: FormBuilder,private router: Router,private route: ActivatedRoute) {
    this.imageLogo="../../../../../assets/images/upload.png"
    this.initForm()
   }

   ngOnInit(): void {
    if (this.route.snapshot.paramMap.get("id")) {
      this.id =this.route.snapshot.paramMap.get("id")
      this.DonationWayService.GetDonationWayByid(this.id).subscribe(async (res:any)=>{
      this.DonationWay=  await res.data;
      this.imageLogo=environment.ServerImages_URL+'/'+this.DonationWay.image
      if(this.DonationWay.amount==0){
        this.DonationWay.amount="0"
      }
        this.initForm(this.DonationWay);
        
      })
      this.update = true;
    } else {
      this.initForm()
      this.update = false;
    }
  }

  initForm(DonationWay?: DonationWay) {
    this.insertForm = this._formBuilder.group({
      Title: [DonationWay?.title || ''],
      TitleAr: [DonationWay?.titleAr || '', Validators.required],
      Description: [DonationWay?.description || ''],
      DescriptionAr: [DonationWay?.descriptionAr || '', Validators.required],
      Amount: [DonationWay?.amount || '', Validators.required],
      Order: [DonationWay?.order || '', Validators.required],
      DonationWayImage: [DonationWay?.image || ''],
    });
  }

  get fc() {
    return this.insertForm.controls;
  }

  
  Submit(){
    if (this.insertForm.status == "VALID") {
      this.BtnDisaple=true;
      if (this.update == true) {
        this.UpdateDonationWay();
      } else {
        this.InsertDonationWay();
      }
    }
     else {
      this.insertForm.markAllAsTouched();
    }
  

  }
  UpdateDonationWay(){
    this.CreatDonationWayorm.set('DonationWayImage', this.Image)
    this.CreatDonationWayorm.set('Title',this.insertForm.get('Title').value)
    this.CreatDonationWayorm.set('TitleAr',this.insertForm.get('TitleAr').value)
    this.CreatDonationWayorm.set('Description',this.insertForm.get('Description').value)
    this.CreatDonationWayorm.set('DescriptionAr',this.insertForm.get('DescriptionAr').value)
    this.CreatDonationWayorm.set('Amount',this.insertForm.get('Amount').value)
    this.CreatDonationWayorm.set('Order',this.insertForm.get('Order').value)
    this.CreatDonationWayorm.set('id',this.id)
    this.DonationWayService.UpdateDonationWay(this.CreatDonationWayorm).subscribe(
      (response) => {
      Swal.fire({
      icon: "success",
      title: "تم التعديل بنجاح",
      showConfirmButton: false,
      timer: 1500,
      });
      this.BtnDisaple=false;
      this.router.navigateByUrl("content/admin/ViewDonationWay");
    },
      (err) => {
        this.BtnDisaple=false;
        Swal.fire({
          icon: "error",
          title:err.error.message
          });
      }
  
      );
  }
  InsertDonationWay(){
    if(this.Image){
      this.CreatDonationWayorm.set('DonationWayImage', this.Image)
    this.CreatDonationWayorm.set('Title',this.insertForm.get('Title').value)
    this.CreatDonationWayorm.set('TitleAr',this.insertForm.get('TitleAr').value)
    this.CreatDonationWayorm.set('Description',this.insertForm.get('Description').value)
    this.CreatDonationWayorm.set('DescriptionAr',this.insertForm.get('DescriptionAr').value)
    this.CreatDonationWayorm.set('Amount',this.insertForm.get('Amount').value)
    this.CreatDonationWayorm.set('Order',this.insertForm.get('Order').value)
    this.DonationWayService.CreateDonationWay(this.CreatDonationWayorm).subscribe(
      (response) => {
      Swal.fire({
      icon: "success",
      title: "تم الحفظ بنجاح",
      showConfirmButton: false,
      timer: 1500,
      });
      this.BtnDisaple=false;

      this.router.navigateByUrl("content/admin/ViewDonationWay");

    },
      (err) => {
        this.BtnDisaple=false;

        Swal.fire({
          icon: "error",
          title:err.error.message
          });
      }
            );
    }
    else{
      this.BtnDisaple=false;

      Swal.fire({
        icon: "error",
        title:"يرجى اختيار الصورة"
        });
    }
 
  }
  OpenImage(imagesView){
    Swal.fire({
      imageUrl: imagesView,
      imageHeight: 400,
      imageAlt: 'A tall image',
      confirmButtonText:"الغاء"
    })
  }
  getLogoUrl(event: any) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      this.Image = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.imageLogo = reader.result as string;
        // this.logoForm?.set("image", this.Image);
      };
    }
  }

}
